<template>
  <div class="professionals-by-procedure-page">
    <h6>Profissionais por Serviço</h6>
    <div class="columns">
      <div class="column col-12 form-group">
        <div class="procedure-list">
          <div class="scroll-list-wrapper">
            <div class="scroll-list">
              <div class="list-header">
                <label class="form-checkbox">
                  <input type="checkbox"
                         @change="selectAllProcedures"
                         :checked="getAllSelected"
                         :indeterminate.prop="getAllSelected === null">
                  <i class="form-icon"></i>
                </label>
                <div class="list-title">Serviços, taxas e outras despesas</div>
                <div class="input-group">
                  <input type="text" class="form-input"
                         v-model="filter"
                         placeholder="Filtrar serviço">
                  <button class="btn btn-neutral btn-action input-group-btn btn-icon"
                          tabindex="-1" v-if="!filter.trim()">
                    <fa-icon :icon="['fal', 'search']"/>
                  </button>
                  <button class="btn btn-gray input-group-btn btn-icon"
                          @click="filter = ''"
                          tabindex="-1" v-else>
                    <fa-icon :icon="['fal', 'times']"/>
                  </button>
                </div>
              </div>
              <table class="table table-hover">
                <tbody>
                <tr v-for="(item, i) in filteredProcedures" :key="i">
                  <td width="30px">
                    <label class="form-checkbox">
                      <input type="checkbox" v-model="item.selected">
                      <i class="form-icon"></i>
                    </label>
                  </td>
                  <td>{{ item.name }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="btn btn-gray btn-icon btn-icon-left mr-1"
              :class="{loading: printing && printType === 'sheet'}"
              :disabled="printing"
              @click="print('sheet')">
        <fa-icon :icon="['fal', 'file-excel']"/>Gerar planilha
      </button>
      <button class="btn btn-primary btn-icon-left"
              :class="{loading: printing && printType === 'pdf'}"
              @click="print('pdf')" :disabled="printing">
        <fa-icon :icon="['fal', 'print']"></fa-icon>Imprimir
      </button>
    </div>
  </div>
</template>

<script>
import fuzzy from 'fuzzy';
import formMixin from '@/mixins/form';

export default {
  mixins: [formMixin],
  data() {
    return {
      printing: false,
      procedureItems: [],
      printType: null,
      filter: '',
    };
  },
  computed: {
    getAllSelected() {
      const items = this.filteredProcedures;
      if (!items || items.length === 0) {
        return false;
      }

      const selected = items.filter(item => item.selected);
      if (selected.length === 0) {
        return false;
      }
      if (selected.length === items.length) {
        return true;
      }
      return null;
    },
    filteredProcedures() {
      let items = this.procedureItems;

      if (this.filter.trim()) {
        const results = fuzzy.filter(this.filter, items, {
          extract: (el) => {
            if (el.name) {
              return this.removeAccentuation(el.name);
            }
            return '';
          },
        });
        items = results.map(({ original }) => original);
      }

      return items;
    },
  },
  mounted() {
    this.loadProcedures();
  },
  methods: {
    selectAllProcedures() {
      const items = this.filteredProcedures;
      const allSelected = this.getAllSelected;
      items.forEach((item) => {
        item.selected = !allSelected;
      });
    },
    loadProcedures() {
      const types = [
        'canteen',
        'consultation',
        'daily',
        'evaluation',
        'exam',
        'gas',
        'laboratory',
        'material',
        'medicine',
        'others',
        'physiotherapy',
        'procedure',
        'service',
        'session',
        'surgery',
        'tax',
      ];

      const params = {
        limit: 0,
        active: true,
        types: types.join(','),
      };

      return this.$httpX.get('/expenses', { params })
        .then(({ data }) => {
          this.procedureItems = data.items.map(item => ({
            id: item.id,
            name: item.name,
            type: item.type,
            selected: true,
          }));
        })
        .catch(() => {});
    },
    async print(printType) {
      const selectedProcedures = this.procedureItems.filter(({ selected }) => selected);

      if (!selectedProcedures || selectedProcedures.length === 0) {
        this.$toast.error('Selecione o(s) serviço(s)!');
        return null;
      }

      this.printType = printType;
      this.printing = true;

      const params = {
        printType,
        procedureIds: selectedProcedures.map(item => item.id).join(','),
      };

      if (printType === 'sheet') {
        return this.$file
          .download('/reports/professionals-by-procedure', params, {
            name: 'Profissionais por Serviço.xlsx',
          })
          .catch((e) => {
            this.$toast.error(e);
          })
          .then(() => {
            this.printing = false;
          });
      }
      return this.$file
        .print('/reports/professionals-by-procedure', params)
        .then(() => {
          this.printing = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/variables";
@import '~assets/scss/mixins';
.professionals-by-procedure-page {
  .procedure-list {
    display: flex;
    flex-direction: column;
    height: 18rem;
    overflow-y: auto;
    .list-header {
      align-items: center;
      border-bottom: $border-width solid $border-color;
      display: flex;
      padding-bottom: $layout-spacing;
      .list-title {
        flex: 1;
        font-weight: bold;
      }
    }
    .scroll-list-wrapper {
      border: $border-color solid $border-width;
      border-radius: $border-radius;
      flex-grow: 1;
      position: relative;
    }
    .scroll-list {
      bottom: 0;
      overflow-y: auto;
      padding: $layout-spacing $layout-spacing-lg;
      position: absolute;
      top: 0;
      width: 100%;
      @include scroll-bar();
      .table th, .table td {
        padding: 0;
      }
      .table td {
        border-bottom: none;
      }
    }
  }
  .footer {
    margin-top: $layout-spacing-lg;
    text-align: right;
  }
}
</style>
